import Vue from 'vue'
import Vuex from 'vuex'
//import user from './modules/user'
import createLogger from 'vuex/dist/logger'

import axios from 'axios'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        //user 
    },
    state: {
        client: null,
        imageProfile: '/dist/logo-small.png',
        active_cam: false,
        active_qr: false,
        resultQR: null,
        queries: [],
        isLoading: false,
    },
    
    strict: false,
    plugins: debug ? [createLogger()] : [],
    actions: {
        loadAuthUser({dispatch, state, commit}, options = {}) {
            const {withScope = []} = options;
            let params = {
                "session":localStorage.getItem('user-token')
            };

            return axios
                .post('/drawing/checkUserDraw', {
                    params: params
                })
                .then(r => r.data)
                .then(data => {
                    commit('setCurrentUser', data)
                    return data
                })
        },
    },
    getters: {
        getCurrentUser: (state, getters, rootState) => {
            return state.client;
        },
        getProfilePhoto: state => {
            return state.imageProfile;
        },
    },
    mutations: {
        setCurrentUser(state, user) {
            state.client = user
        },
        setProfileImage(state, image){
            state.imageProfile = image;
        },
    },

/*
modules: {user},
export default {
    state,
    getters,
    actions,
    mutations
}
    strict: false,
    plugins: debug ? [createLogger()] : []
    */
})


// WEBPACK FOOTER //
// ./src/store/index.js